const PRODUCT = 'Confluence Cloud';

const buildWorkspaceId = (tenantId: string, activationId: string) => {
	return `ari:cloud:confluence:${tenantId}:workspace/${activationId}`;
};

export const createAtlAttributionHeader = (tenantId: string, activationId: string) => {
	const atlAttributionHeader = {
		atlWorkspaceId: buildWorkspaceId(tenantId, activationId),
		tenantId,
		product: PRODUCT,
		service: 'cc-fe-bifrost',
	};
	return { 'atl-attribution': JSON.stringify(atlAttributionHeader) };
};
